// https://vuex.vuejs.org/en/state.html
let appElement = document.getElementById('app');

export default {
    eventCard: {},
    hallPlan: {},
    hasCoupons: false,
    legendSelected: false,
    legendSelectedPrice: 0,
    mobile: false,
    performanceID: appElement.dataset.performance,
    counters: appElement.dataset.counters,
    // img: appElement.dataset.img
}
